module.exports = __webpack_public_path__ + "static/media/truck.ac0d3cb4.png";